"use strict";

import "./VehiclePOICrossings.css";
import React from "react";
import classnames from "classnames";

import dispatcher from "./../../dispatcher";
import poiStore from "./../../store/pois";
import VehiclePOICrossingsStore from "./../../store/vehiclePOICrossings";
import displayedDetailsStore from "./../../store/displayedDetails";

import vehiclePOICrossingUtils from "./../../utils/vehiclePOICrossing";

import IntervalEditor from "vwa/components/IntervalEditor";
import ProgressBar from "vwa/components/ProgressBar";
import DateTimePicker from "vwa/components/DateTimePicker";
import Toast from "vwa/components/Toast";
import Button from "vwa/components/Button";
import Tabs from "vwa/components/Tabs";
import Pager from "vwa/components/Pager";
import lang from "vwa/lang";
import EEP from "vfu/EEP";

import POISelector from "./POISelector";

import VehiclePOICrossingsTimeline from "./../VehiclePOICrossingsTimeline";
import VehiclePOICrossingsStays from "./../VehiclePOICrossingsStays";
import VehiclePOICrossingsSummaries from "./../VehiclePOICrossingsSummaries";

import getVehiclePOICrossings from "./../../api/getVehiclePOICrossings";

import shouldComponentUpdate from "vwa/shouldComponentUpdate";

const MAX_INTERVAL = 1000 * 60 * 60 * 24 * 31 * 6;

export default class VehiclePOICrossings extends React.Component {

	constructor(props){
		super(props);
		this.initState();
		this.eep = new EEP();
		this.setStoreListeners();
	}
	
	initState(){
		this.state = {
			poiCrossingsDescriptor: null,
			from: Date.parse((function(d){ d.setDate(d.getDate()-1); return d})(new Date())),
			to: Date.now(),
			selectedPOIIds: poiStore.getAll().map(poi => poi._id),
			inProgress: false,
			page: "timeline",
			pois: poiStore.getAll() || []
		};
	}
	
	setStoreListeners(){
		this.eep.on(VehiclePOICrossingsStore, "insert", poiCrossingsDescriptors => this.loadActivity(poiCrossingsDescriptors));
		this.eep.on(VehiclePOICrossingsStore, "update", poiCrossingsDescriptor => this.loadActivity([poiCrossingsDescriptor]));
		this.eep.on(displayedDetailsStore, "change", detailsDescriptor => this.handleDetailsStoreChange(detailsDescriptor));
		this.eep.on(poiStore, "change", pois => this.setState({pois}));
	}
	
	shouldComponentUpdate(...nexts){
		return shouldComponentUpdate(this, ...nexts);
	}
	
	componentWillUnmount() {
		this.eep.close();
	}
	
	handleDetailsStoreChange(detailsDescriptor){
		if(detailsDescriptor && detailsDescriptor.id == this.props.vehicleId && vehiclePOICrossingUtils.getVisibilityOfPOICrossings(this.props.vehicleId) && !this.state.poiCrossingsDescriptor){
			this.getPOICrossingsDescriptors();
		}
	}
	
	loadActivity(poiCrossingsDescriptors){
		if(poiCrossingsDescriptors[0].vehicle == this.props.vehicleId){
			this.setState({poiCrossingsDescriptor: poiCrossingsDescriptors[0]});
		}
	}
	
	async getPOICrossingsDescriptors(){
		this.setState({inProgress: true});
		dispatcher.dispatch("clearVehiclePOICrossings", this.props.vehicleId);
		await getVehiclePOICrossings({
			vehicleId: this.props.vehicleId,
			from: this.state.from,
			to: this.state.to,
			poi: this.state.selectedPOIIds
		});
		this.setState({inProgress: false});
	}
	
	componentDidMount(){
		if(openedDetailsStore.get(this.props.vehicleId).activePage == "poiCrossings"){
			this.getPOICrossingsDescriptors();
		}
	}
	
	render(){
		const intervalEditorProps = {
			nullable: false,
			interval: {
				from: this.state.from,
				to: this.state.to
			},
			onChange: interval => {
				if(interval.to - interval.from > MAX_INTERVAL){
					new Toast(lang.TOO_LONG_INTERVAL, "Orange");
				}
				this.setState({
					from: interval.from,
					to: interval.to
				});
			}
		}
		
		const noResult = ( !this.state.inProgress &&
							this.state.poiCrossingsDescriptor &&
							this.state.poiCrossingsDescriptor.result &&
							this.state.poiCrossingsDescriptor.result.crossings.length == 0);
		
		const resultClassNames = classnames("Result", {"Invisible": this.state.inProgress || !this.state.poiCrossingsDescriptor || noResult});
		
		return(
			<div className="VehiclePOICrossings">
				<header className="Shadowed">
					<div className="IntervalEditorContainer">
						<IntervalEditor {...intervalEditorProps} />
						<POISelector onChange={selectedPOIIds => this.setState({selectedPOIIds})} pois={this.state.pois}/>
						<Button className="Red" disabled={this.state.inProgress || this.state.from && this.state.to && (this.state.to - this.state.from > MAX_INTERVAL)} onClick={_ => this.getPOICrossingsDescriptors()}>{lang.SUBMIT}</Button>
					</div>
					<Tabs
						selected={this.state.page}
						onChange={id => this.setState({page: id})}
						className={noResult ? "Hidden" : null}
					>
						<li id="timeline">{lang.TIMELINE}</li>
						<li id="stays">{lang.STAYS}</li>
						<li id="summaries">{lang.SUMMARIES}</li>
					</Tabs>
				</header>
				<div className="Content">
					<ProgressBar indeterminate shown={this.state.inProgress} />
					<h1 className={classnames("Message", {"Hidden": !noResult})} >{lang.NO_RESULTS_FOUND}</h1>
					<Pager active={this.state.page}>
						<div className={resultClassNames} id="timeline">
							<VehiclePOICrossingsTimeline vehicleId={this.props.vehicleId} />
						</div>
						<div className={resultClassNames} id="stays">
							<VehiclePOICrossingsStays vehicleId={this.props.vehicleId} />
						</div>
						<div className={resultClassNames} id="summaries">
							<VehiclePOICrossingsSummaries vehicleId={this.props.vehicleId} />
						</div>
					</Pager>
				</div>
			</div>
		);
	}

}

VehiclePOICrossings.propTypes = {
	vehicleId: React.PropTypes.string
};

VehiclePOICrossings.defaultProps = {
	vehicleId: ""
};


// WEBPACK FOOTER //
// ./src/view/VehiclePOICrossings/VehiclePOICrossings.jsx